import { LeagueRowView } from '../../../../../core/views/components';

export class FantasyLeagueRowView extends LeagueRowView {
	initialize() {
		let { rounds } = this.options,
			is_round_bye = rounds.is_current_round_bye;

		this.model
			.set( {
				current_round: (rounds && rounds.actual) ? rounds.actual.toJSON() : {},
				is_round_bye
			} );

		super.initialize();
	}
}

export default FantasyLeagueRowView;